const SET_SUMMARIES = 'SET_SUMMARIES'
const GET_SUMMARIES = 'GET_SUMMARIES'
const GENERATE_SUMMARY = 'GENERATE_SUMMARY'
const SET_SUMMARY = 'SET_SUMMARY'
const RESET_LOADING = 'RESET_LOADING'
export const setSummaries = (data, conversationId) => {
  return {
    type: SET_SUMMARIES,
    payload: [...data],
    conversationId,
  }
}

export const getSummaries = () => {
  return {
    type: GET_SUMMARIES,
  }
}

export const createSummary = () => {
  return {
    type: GENERATE_SUMMARY,
  }
}

export const setSummary = () => {
  return {
    type: SET_SUMMARY,
  }
}

export const resetLoading = () => {
  return {
    type: RESET_LOADING,
  }
}
